import {
  GET_USER,
  NO_USER_FOUND,
  USER_IS_LOADING,
  PROGRESS_UPLOADING_PERCENTAGE,
} from '../actions/types';

import {me} from './CustomQuery';
import moment from 'moment-timezone';
import {updateAdmin} from '../../modules/Accounts/AccountsQueries';
import {generateClient, GraphQLResult} from 'aws-amplify/api';
import {signIn} from 'aws-amplify/auth';
const client = generateClient();

export const setUploadingProgress = (uploadingProgress: number) => {
  console.log('UPLADETEEEE', uploadingProgress);
  return {type: PROGRESS_UPLOADING_PERCENTAGE, payload: uploadingProgress};
};

export const setLastSeenOnline = () => {
  return async (dispatch, getState: any) => {
    let user = getState().user.user;
    console.log('Setting last seen online', user);
    if (user?.admin?.id) {
      const adminResp: GraphQLResult<any> = await client.graphql({
        query: updateAdmin,
        variables: {
          id: user?.admin?.id,
          updatedAt: user?.admin.updatedAt,
          input: {
            lastSeenOnline: moment().utc().format(),
          },
        },
      });

      console.log('user.user', user);
      let userModify = {
        ...user,
        admin: adminResp?.data?.updateAdmin,
      };
      console.log('userModify', userModify);
      dispatch({
        type: GET_USER,
        payload: userModify,
      });
    }
  };
};

export const doSignIn =
  (email: string, password: string) => async (dispatch: any, getState: any) => {
    dispatch({type: USER_IS_LOADING, payload: true});
    try {
      await signIn({
        username: email,
        password: password,
        options: {
          clientMetadata: {
            typeLogin: 'Admins',
          },
        },
      });
      dispatch({type: USER_IS_LOADING, payload: false});

      dispatch(getMe());
    } catch (error: any) {
      console.log('SIGN_IN_ERROR1', error?.message);
      dispatch(isLoadingUser(false));
      alert(
        error?.message?.includes('Not Authorized')
          ? ' You are not authorized to login in'
          : error,
      );
    }
  };

export const getMe = () => {
  return async (dispatch: any, getState: any) => {
    console.log('ENTER_GET_USER');
    dispatch({type: USER_IS_LOADING, payload: true});

    try {
      let userResponse: GraphQLResult<any> = await client.graphql({
        query: me,
        variables: {},
      });

      const user = userResponse.data.me;
      if (user) {
        dispatch({type: GET_USER, payload: user});
        dispatch({type: USER_IS_LOADING, payload: false});

        console.log('CURRENT_USER', user);
      } else {
        console.log('ERROR_NO_USER_FOUND');
        dispatch({type: NO_USER_FOUND});
      }
    } catch (error) {
      console.log('ERROR_GET_USER', error);
      dispatch({type: USER_IS_LOADING, payload: false});
      // dispatch(doSignOut());
    }
  };
};

export const resetUser = () => async (dispatch: any) => {
  try {
    dispatch({type: 'RESET_USER'});
  } catch (error) {
    console.log('reset user-> ', error);
  }
  // dispatch(getUser());
};

export const isLoadingUser = (isLoading: boolean) => {
  return {
    type: USER_IS_LOADING,
    payload: isLoading,
  };
};
